const BASE_URL = "/master-data/posting-setup";

export default [
  {
    path: `${BASE_URL}/general-posting-setup`,
    name: "GeneralPostingIndex",
    component: () => import("@/pages/masterData/generalPostingSetup/Index.vue"),
  },
  {
    path: `${BASE_URL}/inventory-posting-setup`,
    name: "InventoryPostingSetupIndex",
    component: () => import("@/pages/masterData/inventoryPostingSetup/Index.vue"),
  },
  {
    path: `${BASE_URL}/user-posting-setup`,
    name: "UserPostingSetupIndex",
    component: () => import("@/pages/masterData/userPostingSetup/Index.vue"),
  },
  {
    path: `${BASE_URL}/inventory-reconciliation-setup`,
    name: "InventoryReconciliationSetupIndex",
    component: () => import("@/pages/masterData/inventoryReconciliationSetup/Index.vue"),
  },
];
